import { Epic } from 'redux-observable';
import { from, of } from 'rxjs';
import { map, catchError, filter, switchMap } from 'rxjs/operators';

import { fetchCreditReviewLevels } from 'services';
import { isOfType } from 'utils/isOfType/isOfType';

import {
  Actions,
  CreditReviewLevelsActionTypes,
  requestCreditRequestLevelsSuccessAction,
  requestCreditRequestLevelsErrorAction,
} from './creditReviewLevelsActions';

export const creditReviewLevelsEpic: Epic<Actions, Actions> = action$ =>
  action$.pipe(
    filter(isOfType(CreditReviewLevelsActionTypes.Request)),
    switchMap(() =>
      from(fetchCreditReviewLevels()).pipe(
        map(response => requestCreditRequestLevelsSuccessAction(response)),
        catchError(() =>
          of(requestCreditRequestLevelsErrorAction('Failed to load credit review levels')),
        ),
      ),
    ),
  );
